/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col
} from "reactstrap";
// core components
import UserHeader from "components/Headers/UserHeader.js";
import { connect } from "react-redux";
import axios from 'axios';
import {addUser} from 'actions/index';


function mapDispatchToProps(dispatch) {
  return {
    addUser: user => dispatch(addUser(user))
  };
}

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      full_name: '',    
      user:this,
    };  

    this.handleChange = this.handleChange.bind(this); 
    this.getUserData = this.getUserData.bind(this); 
  }

  componentDidMount(){
    //console.log('props',this.props);
    this.setState({full_name:localStorage.getItem('full_name')});    
    this.getUserData();
  }
  
  handleChange(event){
    const target = event.target;
    const value =  target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  getUserData() {
    let token = localStorage.getItem('access_token');
    axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/user',{headers: {
        'Authorization': `Bearer ${token}` 
      }}).then(res=>{
          //console.log('got user data',res.data.user);
         this.props.addUser(res.data.user);  
         this.setState({user:res.data.user});   
      }).catch(error =>{
          //console.log('error',error);
      });    
  }

  render() {
    return (
      <>
        <UserHeader />
        <Container className="mt--7" fluid>
          <Row>
            
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">My account</h3>
                    </Col>                    
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      User information
                    </h6>
                    <div className="pl-lg-4">
                      
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-first-name"
                            >
                              First name
                            </label>
                            <Input
                              name="name"
                              className="form-control-alternative"
                              value={this.state.user.name}
                              id="input-first-name"
                              placeholder="First name"
                              type="text"
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              Last name
                            </label>
                            <Input
                            name="surname"
                            value={this.state.user.surname}
                              className="form-control-alternative"
                              id="input-last-name"
                              placeholder="Last name"
                              type="text"
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </Col>
                        
                      </Row>
                    </div>
                    <hr className="my-4" />
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
export default connect(null,mapDispatchToProps)(Profile);
